<template>
    <div>
        <FormItem prop="shouhuoxinxi" label="收货信息" style="margin-top: 40px;">
            <div v-if="!editable && data && ((!data.shouhuodiqu||!data.shouhuodiqu[0]) && !data.shouhuodizhi && !data.shouhuorenxingming && !data.shouhuodianhua)" style="color: #aaa;margin-bottom: 20px;">
                未填写
            </div>
            <div style="display: flex;">
                <FormItem prop="shouhuodiqu" label="地区" style="margin-right: 10px;" v-if="editable || data.shouhuodizhi">
                    <div style="margin-top: 2px;min-width: 200px;" v-if="editable">
                        <Cascader :data="diqudata" v-model="form.shouhuodiqu" filterable @on-change="diquChanged"></Cascader>
                    </div>
                    <div v-else>{{data.shouhuodiqu?data.shouhuodiqu.join('/'):''}}</div>
                </FormItem>
                <FormItem prop="shouhuodizhi" label="详细地址" style="margin-right: 10px;" v-if="editable || data.shouhuodizhi">
                    <Input v-model="form.shouhuodizhi" placeholder="请输入" v-if="editable" :style="`width: ${data && data.menpaihao?220:280}px;`">
                    </Input>
                    <div v-else>{{data.shouhuodizhi}}</div>
                </FormItem>
                <FormItem prop="menpaihao" label="门牌号" style="margin-right: 10px;" v-if="data && data.menpaihao">
                    <Input v-model="form.menpaihao" placeholder="请输入" v-if="editable" style="width: 80px;">
                    </Input>
                    <div v-else>{{data.menpaihao||''}}</div>
                </FormItem>
                <FormItem prop="shouhuorenxingming" label="收货人姓名" style="margin-right: 10px;" v-if="editable || data.shouhuorenxingming">
                    <Input v-model="form.shouhuorenxingming" placeholder="请输入" v-if="editable" style="width: 100px;">
                    </Input>
                    <div v-else>{{data.shouhuorenxingming}}</div>
                </FormItem>
                <FormItem prop="shouhuodianhua" label="收货电话" style="margin-right: 10px;" v-if="editable || data.shouhuodianhua">
                    <Input v-model="form.shouhuodianhua" placeholder="请输入" v-if="editable" :style="`width: ${data && data.menpaihao?110:140}px;`">
                    </Input>
                    <div v-else>{{data.shouhuodianhua}}</div>
                </FormItem>
                <FormItem prop="beizhu" label="备注" style="width: 200px;" v-if="options && options.beizhuOn">
                    <Input v-model="form.beizhu" placeholder="请输入" v-if="editable">
                    </Input>
                    <div v-else>{{data.beizhu}}</div>
                    <div v-if="!editable && !data.beizhu" style="color: #aaa;">无</div>
                </FormItem>
            </div>
        </FormItem>
        <Poptip trigger="hover" placement="right-start" transfer v-if="editable">
            <div class="hover" style="color:#20bf64;font-weight: bold;">智能识别地址</div>
            <div slot="content" v-if="addressParseModal">
                <div style="height: 10px;"></div>
                <div class="df">
                    <Input v-model="addressParseModal.content" style="width: 400px;" placeholder="请输入待识别文字" @input="addressParseModal.calculate()" @on-enter="addressParseModal.confirm" />
                    <Button type="primary" @click="addressParseModal.confirm" style="margin-left: 12px;">应用</Button>
                </div>
                <div style="height: 110px;">
                    <div style="color: #aaa;" v-if="addressParseModal.result && addressParseModal.result.shouhuodizhi">
                        <div style="height: 10px;"></div>
                        <div v-if="addressParseModal.result.shouhuodiqu && addressParseModal.result.shouhuodiqu[0]">
                            <Icon type="md-checkmark" color="#20bf64" /> {{addressParseModal.result.shouhuodiqu.join('/')}}
                        </div>
                        <div v-if="addressParseModal.result.shouhuodizhi">
                            <Icon type="md-checkmark" color="#20bf64" /> {{addressParseModal.result.shouhuodizhi}}
                        </div>
                        <div v-if="addressParseModal.result.shouhuorenxingming">
                            <Icon type="md-checkmark" color="#20bf64" /> {{addressParseModal.result.shouhuorenxingming}}
                        </div>
                        <div v-if="addressParseModal.result.shouhuodianhua">
                            <Icon type="md-checkmark" color="#20bf64" /> {{addressParseModal.result.shouhuodianhua}}
                        </div>
                    </div>
                    <div class="center" style="width: 100%;height: 100%;color: #aaa;" v-else>
                        暂无识别结果
                    </div>
                </div>
            </div>
        </Poptip>
    </div>
</template>

<script>

    export default {
        props: {
            form: Object,
            data: {
                type: Object,
                default: () => ({})
            },
            editable: {
                type: Boolean,
                default: true,
            },
            options: {
                type: Object,
                default: () => ({})
            },
        },
        data() {
            const diqudata = this.$chinapcdata.map(p => ({ code: p.code, value: p.name, label: p.name, children: p.children ? p.children.map(c => ({ code: c.code, label: c.name, value: c.name, children: c.children ? c.children.map(d => ({ code: d.code, value: d.name, label: d.name })) : [] })) : [] }))
            return {
                diqudata,
                addressParseModal: {
                    content: '',
                    result: {},
                    calculate: () => {
                        let address = this.addressParseModal.content
                        let r = this.$parseAddress(address)
                        let { province, city, area, detail, name, phone } = r

                        let provinceData = null
                        let cityData = null
                        if (province) {
                            provinceData = diqudata.find(item => item.value == province)
                            if (!provinceData) province = null
                        }

                        if (province == '新疆维吾尔自治区' && city && !area) { // 新疆维吾尔自治区/自治区直辖县级行政区划/可克达拉市  这种被识别为 province:新疆维吾尔自治区 city:可克达拉市 area:'', 实际应是 province: 新疆维吾尔自治区 city:自治区直辖县级行政区划 area:可克达拉市
                            area = city
                        }

                        if (province && city) {
                            cityData = provinceData.children.find(item => item.value == city)
                            if (!cityData && provinceData.children[0].children.find(item => item.value == area)) {
                                cityData = provinceData.children[0]
                                city = cityData.value
                            }
                            if (!cityData) city = null
                        }

                        if (province && !city && area) {
                            for (let child of provinceData.children) {
                                if (child.children.find(item => item.value == area)) {
                                    cityData = child
                                    city = child.value
                                    break
                                }
                            }
                        }

                        if (province && city && area) {
                            let areaData = cityData.children.find(item => item.value == area)
                            if (!areaData) area = null
                        }

                        console.log('parse address', r, province, city, area, detail, name, phone)

                        this.addressParseModal.result = {
                            shouhuodiqu: (province && city && area) ? [province, city, area] : [],
                            shouhuodizhi: detail,
                            shouhuorenxingming: name,
                            shouhuodianhua: phone,
                        }
                    },
                    confirm: () => {
                        // 省市区：有识别结果则更新，无则清空
                        if (this.addressParseModal.result.shouhuodiqu && this.addressParseModal.result.shouhuodiqu[0]) {
                            this.form.shouhuodiqu = this.addressParseModal.result.shouhuodiqu
                        } else {
                            this.form.shouhuodiqu = []
                        }
                        // 详细地址：有识别结果则更新，无则清空
                        if (this.addressParseModal.result.shouhuodizhi) {
                            this.form.shouhuodizhi = this.addressParseModal.result.shouhuodizhi
                        } else {
                            this.form.shouhuodizhi = ''
                        }
                        // 收货人姓名：有识别结果则更新，无则清空
                        if (this.addressParseModal.result.shouhuorenxingming) {
                            this.form.shouhuorenxingming = this.addressParseModal.result.shouhuorenxingming
                        } else {
                            this.form.shouhuorenxingming = ''
                        }
                        // 收货电话：有识别结果则更新，无则清空
                        if (this.addressParseModal.result.shouhuodianhua) {
                            this.form.shouhuodianhua = this.addressParseModal.result.shouhuodianhua
                        } else {
                            this.form.shouhuodianhua = ''
                        }
                        this.diquChanged(this.form.shouhuodiqu)
                    }
                }
            }
        },
        mounted() { },
        methods: {
            diquChanged(value) {
                this.$emit('diquChanged', value)
            }
        },
        created() { },
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/common/AddressInput.vue?3c37856b